// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';

/**
 * 
 * @export
 * @interface IReturnMailOcrDetails
 */
export interface IReturnMailOcrDetails {
    /**
     * 
     * @type {string}
     * @memberof IReturnMailOcrDetails
     */
    type: string;
    /**
     * 
     * @type {IAddress}
     * @memberof IReturnMailOcrDetails
     */
    address?: IAddress;
    /**
     * 
     * @type {string}
     * @memberof IReturnMailOcrDetails
     */
    original_mailing_type?: IReturnMailOcrDetailsOriginalMailingTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IReturnMailOcrDetails
     */
    statement_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IReturnMailOcrDetailsOriginalMailingTypeEnum {
    WELCOME_LETTER = 'WELCOME_LETTER',
    ORPHAN_LETTER = 'ORPHAN_LETTER',
    STATEMENT = 'STATEMENT',
    TAX_FORM = 'TAX_FORM',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the IReturnMailOcrDetails interface.
 */
export function instanceOfIReturnMailOcrDetails(value: object): value is IReturnMailOcrDetails {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IReturnMailOcrDetailsFromJSON(json: any): IReturnMailOcrDetails {
    return IReturnMailOcrDetailsFromJSONTyped(json, false);
}

export function IReturnMailOcrDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnMailOcrDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'original_mailing_type': json['original_mailing_type'] == null ? undefined : json['original_mailing_type'],
        'statement_date': json['statement_date'] == null ? undefined : (new Date(json['statement_date'])),
    };
}

export function IReturnMailOcrDetailsToJSON(json: any): IReturnMailOcrDetails {
    return IReturnMailOcrDetailsToJSONTyped(json, false);
}

export function IReturnMailOcrDetailsToJSONTyped(value?: IReturnMailOcrDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'address': IAddressToJSON(value['address']),
        'original_mailing_type': value['original_mailing_type'],
        'statement_date': value['statement_date'] == null ? undefined : ((value['statement_date']).toISOString().substring(0,10)),
    };
}

